import React from "react";
import BaseCardDeck from './BaseCardDeck';
import baseStyles from '../../../styles/scss/components/industrial/base-card-deck.module.scss';
import verticalStyles from '../../../styles/scss/components/industrial/vertical-card-deck.module.scss';
import badgesStyles from '../../../styles/scss/components/industrial/badges-card-deck.module.scss';
import iconsStyles from '../../../styles/scss/components/industrial/icons-card-deck.module.scss';
import successStoriesStyles from '../../../styles/scss/components/industrial/success-stories-card-deck.module.scss';
import insightsStyles from '../../../styles/scss/components/industrial/insights-card-deck.module.scss';
import faqsStyles from '../../../styles/scss/components/industrial/faqs-card-deck.module.scss';
import productsStyles from '../../../styles/scss/components/industrial/products-card-deck.module.scss';

const variantStyles = {
  base: baseStyles,
  vertical: verticalStyles,
  badges: badgesStyles,
  icons: iconsStyles,
  'success-stories': successStoriesStyles,
  insights: insightsStyles,
  faqs: faqsStyles,
  products: productsStyles
};

export default function CardDeck({ variant = 'base', data, themeColor, pageSlug, ...props }) {
  const styles = variantStyles[variant] || baseStyles;
  return <BaseCardDeck data={data} classes={styles} variant={variant} themeColor={themeColor} pageSlug={pageSlug} {...props} />;
}
